import "./instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

function ErrorFallback({ error }: { error: unknown }) {
  console.error("Erro inesperado na interface:", error);
  return <div>Erro inesperado.</div>;
}

// Force clean rebuild - v2
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={({ error }) => <ErrorFallback error={error} />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
